var _rect, _rect2, _g, _rect3, _rect4, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "#DDDDDD"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Dailer - Contacts (add/remove/view) and account details",
    clipPath: "url(#clip0_303_2)"
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 2350,
    height: 2258,
    transform: "translate(-316 -1058)",
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Rectangle 265",
    filter: "url(#filter0_d_303_2)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -16,
    y: -114,
    width: 318,
    height: 444,
    rx: 12,
    fill: "white"
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 267",
    x: -16,
    y: -16,
    width: 318,
    height: 48,
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    id: "arrow_back"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_303_2",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    width: 16,
    height: 16,
    fill: "#196CCA"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_303_2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "arrow_back_2",
    d: "M5.2165 8.66699L8.94984 12.4003L7.99984 13.3337L2.6665 8.00033L7.99984 2.66699L8.94984 3.60033L5.2165 7.33366H13.3332V8.66699H5.2165Z",
    fill: "#196CCA"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_303_2",
    x: -20,
    y: -114,
    width: 326,
    height: 452,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_303_2"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_303_2",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_303_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 2350,
    height: 2258,
    fill: "white",
    transform: "translate(-316 -1058)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowBack);
export default __webpack_public_path__ + "static/media/arrow_back.f286e2f844b57ee8b4a58ff59934b035.svg";
export { ForwardRef as ReactComponent };